import type { MarketRegime } from '../types/marketAnalytics';

const MATRIX_KEY = 'mmec_regime_transition_matrix_v1';

export type TransitionMatrix = Record<string, Record<string, number>>;

const REGIMES: MarketRegime[] = ['CALM', 'MOMENTUM', 'EXTREME', 'SLEEPY'];

function emptyMatrix(): TransitionMatrix {
  const m: TransitionMatrix = {};
  for (const from of REGIMES) {
    m[from] = {};
    for (const to of REGIMES) m[from][to] = 0;
  }
  return m;
}

export function loadTransitionMatrix(symbol: string): TransitionMatrix {
  try {
    const raw = localStorage.getItem(MATRIX_KEY);
    if (!raw) return emptyMatrix();
    const all = JSON.parse(raw) as Record<string, TransitionMatrix>;
    return all[symbol] ?? emptyMatrix();
  } catch {
    return emptyMatrix();
  }
}

export function recordRegimeTransition(
  symbol: string,
  from: MarketRegime,
  to: MarketRegime,
): TransitionMatrix {
  const matrix = loadTransitionMatrix(symbol);
  matrix[from][to] = (matrix[from][to] ?? 0) + 1;
  try {
    const raw = localStorage.getItem(MATRIX_KEY);
    const all = raw ? (JSON.parse(raw) as Record<string, TransitionMatrix>) : {};
    all[symbol] = matrix;
    localStorage.setItem(MATRIX_KEY, JSON.stringify(all));
  } catch {
    /* ignore */
  }
  return matrix;
}

export function transitionProbability(
  matrix: TransitionMatrix,
  from: MarketRegime,
  to: MarketRegime,
): number | null {
  const row = matrix[from];
  if (!row) return null;
  const total = REGIMES.reduce((s, r) => s + (row[r] ?? 0), 0);
  if (total < 1) return null;
  return (row[to] ?? 0) / total;
}

export { REGIMES };
